export const getAndClearItem = key => {
  const item = sessionStorage.getItem(key)
  sessionStorage.removeItem(key)
  return item
}

export const clearItem = key => {
  return sessionStorage.clear(key)
}

export const setSessionItem = (key, value) => {
  return sessionStorage.setItem(key, value)
}

export const setSessionObjectItem = (key, value) => {
  return sessionStorage.setItem(key, JSON.stringify(value))
}

export const getSessionObjectItem = key => {
  return JSON.parse(sessionStorage.getItem(key))
}

export const getSessionItem = key => {
  return sessionStorage.getItem(key)
}
